// src/features/websites/components/TabPanel.tsx
import React from 'react';
import { Box } from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

/**
 * A reusable TabPanel component for tabbed interfaces
 */
const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`website-tabpanel-${index}`}
      aria-labelledby={`website-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
};

export function a11yProps(index: number) {
  return {
    id: `website-tab-${index}`,
    'aria-controls': `website-tabpanel-${index}`,
  };
}

export default TabPanel;